import { UserInfo } from '@models/user-info.model';

export interface AppStateModel {
  userInfo?: UserInfo;
}

export const AppInitialState = {
  userInfo: undefined,
};
